import React from 'react';
import ClipboardCopy from '@components/common/clipboard_copy/main';

export const Colors = () => {
  const createColorCard = (colorTitle, colorHex, colorRGBA, shade) => (
    <div className="color-card-container">
      <div className={`color-card ${shade}`} style={{ background: colorHex }}>
        <div className="color-title">
          <h4 className="color-text">{colorTitle}</h4>
        </div>
        <div className="color-content">
          <ClipboardCopy
            showFeedbackAsTooltip={false}
            textToCopy={colorHex}
          >
            <h4 className="color-text">{colorHex}</h4>
          </ClipboardCopy>
          <ClipboardCopy
            showFeedbackAsTooltip={false}
            textToCopy={colorRGBA}
          >
            <h4 className="color-text">{colorRGBA}</h4>
          </ClipboardCopy>
        </div>
      </div>
    </div>
  );

  return (
    <div className="example-container">
      <h3>Primary Colors</h3>
      <div className="colors-container">
        {createColorCard('$purple-popsicle', '#4462C9', 'rgba(68, 98, 201, 1)', '')}
        {createColorCard('$blueberry-delight', '#1D3163', 'rgba(29, 49, 99, 1)', '')}
        {createColorCard('$aqua-knockoff', '#00B0F7', 'rgba(0, 176, 247, 1)', '')}
      </div>
      <h3>Secondary Colors</h3>
      <div className="colors-container">
        {createColorCard('$grape-jelly', '#6987D7', 'rgba(105, 135, 215, 1)', '')}
        {createColorCard('$marshmallow', '#F9FBFC', 'rgba(248, 250, 252, 1)', 'light')}
        {createColorCard('$dirty-marshmallow', '#F1F5FA', 'rgba(241, 245, 250, 1)', 'light')}
        {createColorCard('$dirty-marshmallow-half', '#F1F5FA', 'rgba(241, 245, 250, 0.5)', 'light')}
      </div>
      <h3>Typography Colors</h3>
      <div className="colors-container">
        {createColorCard('$title', '#333333', 'rgba(51, 51, 51, 1)', '')}
        {createColorCard('$text', '#4A4A4A', 'rgba(74, 74, 74, 1)', '')}
      </div>
      <h3>Backgrounds and Borders</h3>
      <div className="colors-container">
        {createColorCard('$gray', '#E6E6E6', 'rgba(230, 230, 230, 1)', 'light')}
        {createColorCard('$gray-medium', '#CBCBCB', 'rgba(203, 203, 203, 1)', 'light')}
        {createColorCard('$gray-medium-dark', '#9B9B9B', 'rgba(155, 155, 155, 1)', '')}
        {createColorCard('$gray-dark', '#6F6F6F', 'rgba(111, 111, 111, 1)', '')}
        {createColorCard('$border-gray', '#CECECE', 'rgba(206, 206, 206, 1)', 'light')}
      </div>
      <h3>Flash Messages</h3>
      <div className="colors-container">
        {createColorCard('$warning-red', '#F64E63', 'rgba(246, 78, 99, 1)', '')}
        {createColorCard('$orange', '#FFA400', 'rgba(255, 164, 0, 1)', '')}
        {createColorCard('$yellow', '#EFE860', 'rgba(239, 232, 96, 1)', '')}
        {createColorCard('$success-green', '#59E287', 'rgba(89, 226, 135, 1)', '')}
      </div>
    </div>
  );
};
